import React from "react";
import NavbarTop from "../components/NavbarTop";
import NavbarBottom from "../components/NavbarBottom";
import NotificationLists from "../components/NotificationLists";

const Notifications = () => {
  return (
    <div>
      <NavbarTop />
      <NotificationLists />
      <NavbarBottom />
    </div>
  );
};

export default Notifications;
